import React from "react";
import Equipment01 from "../images/Equipment01.webp";
import Microphone01 from "../images/Microphone01.webp";
import Microphone02 from "../images/Microphone02.webp";
import Microphone03 from "../images/Microphone03.webp";
import Microphone04 from "../images/Microphone04.webp";
import OnTheAir01 from "../images/OnTheAir01.webp";
import Panel01 from "../images/Panel01.webp";
import Panel02 from "../images/Panel02.webp";
import Panel03 from "../images/Panel03.webp";
import Panel04 from "../images/Panel04.webp";
import Studio01 from "../images/Studio01.webp";
import Studio02 from "../images/Studio02.webp";
import Tower00 from "../images/Tower00.webp";
import Icon00 from "../icons/phone-solid.svg";
import Icon01 from "../icons/envelope-open-text-solid.svg";
import Icon02 from "../icons/computer-solid.svg";
import Image00 from "../images/Jake&Othell00.webp";
import Image01 from "../images/Jake&Othell01.webp";
import Image02 from "../images/Jake&Othell02.webp";

const Contact = () => {
  return (
    <div className="container">
      <div class="carousel">
        <div
          id="carouselExampleAutoplaying"
          class="carousel slide"
          data-bs-ride="carousel"
        >
          <div class="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="0"
              class="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="3"
              aria-label="Slide 4"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="4"
              aria-label="Slide 5"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="5"
              aria-label="Slide 6"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="6"
              aria-label="Slide 7"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="7"
              aria-label="Slide 8"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="8"
              aria-label="Slide 9"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="9"
              aria-label="Slide 10"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="10"
              aria-label="Slide 11"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="11"
              aria-label="Slide 12"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to="12"
              aria-label="Slide 13"
            ></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active" data-bs-interval="10000">
              <img src={Studio02} class="d-block w-100" alt="..." />
            </div>
            <div class="carousel-item">
              <img src={Panel01} class="d-block w-100" alt="..." />
            </div>
            <div class="carousel-item">
              <img src={Studio01} class="d-block w-100" alt="..." />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Microphone02}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Panel02}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Microphone01}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Microphone03}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Panel03}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Equipment01}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img src={Microphone04} class="d-block w-100" alt="..." />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Panel04}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={OnTheAir01}
                class="d-block w-100"
                alt="..."
              />
            </div>
            <div class="carousel-item">
              <img
                loading="lazy"
                src={Tower00}
                class="d-block w-100"
                alt="..."
              />
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleAutoplaying"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <div class="container-contact">
        <div class="contact">
          <h2>Contact Us</h2>
          <p>
            <img src={Icon00} class="contact-icon" alt="" />
            Call Us At&#58; (619) 772-8680
          </p>
          <p>
            <img src={Icon01} class="contact-icon" alt="" /> Mail Us At&#58;
            P.O. Box 10, La Mesa, CA 91944
          </p>
          <p>
            <img src={Icon02} class="contact-icon-email" id="email" alt="" />
            Email Us At&#58; G2RadioNetwork@G2RadioNetwork.com
          </p>
        </div>

        <div class="row">
          <div class="column-image">
            <img
              loading="lazy"
              src={Image00}
              alt="Jake and Othell 00."
              class="contact_image"
            />
            <img
              loading="lazy"
              src={Image01}
              alt="Jake and Othell 01."
              class="contact_image"
            />
            <img
              loading="lazy"
              src={Image02}
              alt="Jake and Othell 02."
              class="contact_image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
